import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoginComponent } from "./login.component";
import { LoginRoutes } from "./login.routing";
import { LocalService } from "app/services/local.service";
import { PageService } from "app/services/page-service";
import { AuthService } from "app/services/auth.service";
import { AuthGuard } from "app/guards/auth-guard.service";
import { StorageService } from "app/services/storage.service";
import { BrowserModule } from "@angular/platform-browser";
import { ModulesAuthGuardService } from "app/guards/modules-auth-guard.service";
import { ModuleauthService } from "app/services/moduleauth.service";

@NgModule({
  declarations: [LoginComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(LoginRoutes),
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
  ],
  providers: [
    PageService,
    LocalService,
    AuthService,
    AuthGuard,
    ModulesAuthGuardService,
    ModuleauthService,
    StorageService,
  ],
})
export class LoginModule {}
